import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Col, Nav, Row, Tab, Tabs } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import { toastr } from "react-redux-toastr";
import Loader from "../Shared/loader";
import moment from "moment";

const sliderStyles = `
  body.details-slider-open {
    overflow: hidden;
  }
  
  .details-slider-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  
  .details-slider-overlay.show {
    opacity: 1;
    pointer-events: all;
  }
  
  .details-slider-panel {
    position: fixed;
    top: 0;
    right: -600px;
    width: 600px;
    max-width: 90vw;
    height: 100%;
    background: #ffffff;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 1050;
    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  .details-slider-panel.open {
    right: 0;
  }
  
  .details-slider-content {
    background: #ffffff;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }
  
  .details-slider-header {
    background: #453acd;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  
  .details-slider-header h5 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
  
  .details-slider-close {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 18px;
  }
  
  .details-slider-close:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  .details-slider-action-btn {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    outline: none;
  }
  
  .details-slider-action-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .details-slider-action-btn:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
  
  .details-slider-action-btn i {
    font-size: 14px;
    color: white;
  }
  
  .details-slider-action-btn-text {
    color: white;
  }
  
  .details-slider-tabs {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    flex-shrink: 0;
  }
  
  .details-slider-tab {
    flex: 1;
    padding: 12px 20px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    color: #495057;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .details-slider-tab:hover {
    background: #e9ecef;
    color: #453acd;
  }
  
  .details-slider-tab.active {
    background: #ffffff;
    color: #453acd;
    border-bottom-color: #453acd;
  }
  
  .details-slider-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
  }
  
  .details-section {
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .details-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
  }
  
  .details-section-title i {
    color: #453acd;
    font-size: 1rem;
  }
  
  .details-info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f1f3f5;
  }
  
  .details-info-item:last-child {
    border-bottom: none;
  }
  
  .details-info-label {
    font-weight: 600;
    color: #495057;
    min-width: 140px;
    flex-shrink: 0;
    font-size: 0.9rem;
  }
  
  .details-info-value {
    color: #212529;
    flex: 1;
    word-break: break-word;
    font-size: 0.9rem;
  }
  
  @media (max-width: 768px) {
    .details-slider-panel {
      width: 100vw;
      right: -100vw;
    }
  }
`;

const Management = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [domainDetails, setDomainDetails] = useState([]);
  const [stats, setStats] = useState({});
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);

  // Additional assets state
  const [socialMediaData, setSocialMediaData] = useState([]);
  const [vipMembers, setVipMembers] = useState([]);
  const [keywords, setKeywords] = useState([]);

  // Domain expiry analysis
  const [domainExpiryStats, setDomainExpiryStats] = useState({
    expiringSoon: 0,
    criticalExpiry: 0
  });

  // Active tab state
  const [activeTab, setActiveTab] = useState("overview");
  
  // DNS Details Modal state
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [detailsActiveTab, setDetailsActiveTab] = useState('dns');

  // Get organization ID from user state or params
  const params = useParams();
  const org = JSON.parse(localStorage.getItem('org')) || {};
  const organisationId = org._id || params.organisationId;
  const orgName = org.name || org.organizationName || org.orgName || "organization";
  const orgNameSlug = orgName.replace(/\s+/g, "-");

  // Shared Excel downloader
  const downloadExcel = async (endpoint, filename) => {
    try {
      const session = localStorage.getItem("session");
      if (!session) {
        toastr.error("Error", "Authentication required");
        return;
      }

      const response = await axios.get(`${API_URL}${endpoint}`, {
        headers: {
          Authorization: `Bearer ${session}`,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      const message = error.response?.data?.userMessage || "Failed to download file";
      toastr.error("Error", message);
    }
  };

  const handleDownloadDomainStats = () =>
    downloadExcel(`/domain-details/${organisationId}/stats/excel`, `${orgNameSlug}-domain-stats.xlsx`);

  const handleDownloadSocialMedia = () =>
    downloadExcel(`/social-media-data/${organisationId}/excel`, `${orgNameSlug}-social-media.xlsx`);

  const handleDownloadVipMembers = () =>
    downloadExcel(`/executive-monitoring/${organisationId}/vip-members/excel`, `${orgNameSlug}-vip-members.xlsx`);

  const handleDownloadKeywords = () =>
    downloadExcel(`/customer/${organisationId}/keywords/excel`, `${orgNameSlug}-keywords.xlsx`);

  // Fetch domain details
  const fetchDomainDetails = async (page = 1) => {
    try {
      const session = localStorage.getItem("session");
      if (!session) {
        toastr.error("Error", "Authentication required");
        return;
      }

      const response = await axios.get(
        `${API_URL}/domain-details/${organisationId}?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${session}`,
          },
        }
      );

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        const domains = response.data.data.domainDetails;
        setDomainDetails(domains);
        setPagination({
          totalDomains: response.data.data.totalDomains,
          page: response.data.data.page,
          limit: response.data.data.limit,
          totalPages: response.data.data.totalPages,
        });
        // Analyze domain expiry status
        analyzeDomainExpiry(domains);
      }
    } catch (error) {
      const message = error.response?.data?.userMessage || "Failed to fetch domain details";
      toastr.error("Error", message);
    }
  };

  // Fetch domain statistics
  const fetchDomainStats = async () => {
    try {
      const session = localStorage.getItem("session");
      if (!session) {
        toastr.error("Error", "Authentication required");
        return;
      }

      const response = await axios.get(
        `${API_URL}/domain-details/${organisationId}/stats`,
        {
          headers: {
            Authorization: `Bearer ${session}`,
          },
        }
      );

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        setStats(response.data.data);
      }
    } catch (error) {
      const message = error.response?.data?.userMessage || "Failed to fetch domain statistics";
      toastr.error("Error", message);
    }
  };

  // Fetch social media data
  const fetchSocialMediaData = async () => {
    try {
      const session = localStorage.getItem("session");
      if (!session) {
        toastr.error("Error", "Authentication required");
        return;
      }

      const response = await axios.get(
        `${API_URL}/social-media-data/${organisationId}?page=1&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${session}`,
          },
        }
      );

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        setSocialMediaData(response.data.data?.posts || []);
      }
    } catch (error) {
      const message = error.response?.data?.userMessage || "Failed to fetch social media data";
      toastr.error("Error", message);
    }
  };

  // Fetch VIP members
  const fetchVipMembers = async () => {
    try {
      const session = localStorage.getItem("session");
      if (!session) {
        toastr.error("Error", "Authentication required");
        return;
      }

      const response = await axios.get(
        `${API_URL}/executive-monitoring/${organisationId}/vip-members`,
        {
          headers: {
            Authorization: `Bearer ${session}`,
          },
        }
      );

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        setVipMembers(response.data.data || []);
      }
    } catch (error) {
      const message = error.response?.data?.userMessage || "Failed to fetch VIP members";
      toastr.error("Error", message);
    }
  };

  // Get keywords from organization data
  const getKeywords = () => {
    if (org && org.keyWord) {
      setKeywords(Array.isArray(org.keyWord) ? org.keyWord : []);
    } else {
      setKeywords([]);
    }
  };

  // Analyze domain expiry status
  const analyzeDomainExpiry = (domains) => {
    let expiringSoon = 0;
    let criticalExpiry = 0;

    domains.forEach(domain => {
      const expiryDate = domain.whoisInfo?.registrar_registration_expiration_date;
      if (isDomainCriticalExpiry(expiryDate)) {
        criticalExpiry++;
      } else if (isDomainExpiryNearing(expiryDate)) {
        expiringSoon++;
      }
    });

    setDomainExpiryStats({ expiringSoon, criticalExpiry });
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchDomainDetails(page);
  };

  // Handle tab switching from overview cards
  const handleTabSwitch = (tabKey) => {
    setActiveTab(tabKey);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  // Check if domain is active (not expired)
  const isDomainActive = (expirationDate) => {
    if (!expirationDate) return false;
    return new Date(expirationDate) > new Date();
  };

  // Check if domain expiry is nearing (within 30 days)
  const isDomainExpiryNearing = (expirationDate) => {
    if (!expirationDate) return false;
    const expiryDate = new Date(expirationDate);
    const now = new Date();
    const daysUntilExpiry = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
    return daysUntilExpiry <= 30 && daysUntilExpiry > 0;
  };

  // Check if domain is critically expiring (within 7 days)
  const isDomainCriticalExpiry = (expirationDate) => {
    if (!expirationDate) return false;
    const expiryDate = new Date(expirationDate);
    const now = new Date();
    const daysUntilExpiry = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
    return daysUntilExpiry <= 7 && daysUntilExpiry > 0;
  };

  // Render DNS records grouped by type
  const renderDNSRecords = () => {
    if (!selectedRowDetails?.dnsDetails?.dnsRecords || selectedRowDetails.dnsDetails.dnsRecords.length === 0) {
      if (selectedRowDetails?.dnsDetails) {
        return (
          <div className="details-section">
            <div className="text-center p-4">
              <i className="fa fa-info-circle fa-3x text-muted mb-3"></i>
              <h6 className="text-muted">No DNS Records Found</h6>
              <p className="text-muted small">DNS records are not available for this domain.</p>
            </div>
          </div>
        );
      }
      return null;
    }

    // Group DNS records by type
    const groupedRecords = {};
    selectedRowDetails.dnsDetails.dnsRecords.forEach(record => {
      const type = record.dnsType || 'UNKNOWN';
      if (!groupedRecords[type]) {
        groupedRecords[type] = [];
      }
      groupedRecords[type].push(record);
    });

    const dnsTypes = Object.keys(groupedRecords);
    return (
      <>
        {dnsTypes.map((dnsType) => (
          <div key={dnsType} className="details-section">
            <div className="details-section-title">
              <i className="fa fa-list"></i>
              {dnsType} Records ({groupedRecords[dnsType].length})
            </div>
            {groupedRecords[dnsType].map((record, index) => (
              <div key={index} className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start", padding: "12px 0", borderBottom: "1px solid #f1f3f5" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ marginBottom: "8px" }}>
                    <strong>Name:</strong> {record.name || "N/A"}
                  </div>
                  <div style={{ marginBottom: "8px" }}>
                    <strong>TTL:</strong> {record.ttl || "N/A"}
                  </div>
                  {record.address && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Address:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.address}</code>
                    </div>
                  )}
                  {record.singleName && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Name Server:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.singleName}</code>
                    </div>
                  )}
                  {record.target && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Target:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.target}</code>
                      {record.priority !== undefined && (
                        <span className="ml-2">
                          <strong>Priority:</strong> {record.priority}
                        </span>
                      )}
                    </div>
                  )}
                  {record.strings && record.strings.length > 0 && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Value:</strong>
                      <div style={{ marginTop: "4px" }}>
                        {record.strings.map((str, strIndex) => (
                          <code key={strIndex} style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px", display: "block", marginBottom: "4px" }}>
                            {str}
                          </code>
                        ))}
                      </div>
                    </div>
                  )}
                  {record.host && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Host:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.host}</code>
                    </div>
                  )}
                  {record.admin && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Admin:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.admin}</code>
                    </div>
                  )}
                  {record.serial !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Serial:</strong> {record.serial}
                    </div>
                  )}
                  {record.refresh !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Refresh:</strong> {record.refresh}s
                    </div>
                  )}
                  {record.retry !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Retry:</strong> {record.retry}s
                    </div>
                  )}
                  {record.expire !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Expire:</strong> {record.expire}s
                    </div>
                  )}
                  {record.minimum !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Minimum:</strong> {record.minimum}s
                    </div>
                  )}
                  {record.rawText && (
                    <div style={{ marginTop: "8px", padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
                      <strong>Raw Text:</strong>
                      <pre style={{ margin: "4px 0 0 0", fontSize: "0.85em", whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                        {record.rawText}
                      </pre>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </>
    );
  };

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  useEffect(() => {
    const loadData = async () => {
      if (!organisationId) {
        toastr.error("Error", "Organization not found. Please select an organization and try again.");
        setLoading(false);
        return;
      }

      setLoading(true);
      await Promise.all([
        fetchDomainDetails(currentPage),
        fetchDomainStats(),
        fetchSocialMediaData(),
        fetchVipMembers()
      ]);
      getKeywords();
      setLoading(false);
    };

    loadData();
  }, [organisationId, currentPage]);

  if (loading) {
    return (
      <div className="container-fluid">
        <Loader type="Puff" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }

  return (
    <>
      <style>{sliderStyles}</style>
      <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h2>Management</h2>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/" className="welcome-textSmall">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Management
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {/* Assets Overview Tabs */}
      <div className="row clearfix">
        <div className="col-12">
          <div className="card">
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="asset-tabs" className="nav-tabs-custom">
              <Tab eventKey="overview" title={<span><i className="fa fa-chart-line mr-2"></i>Overview</span>}>
                <div className="body">
                  {/* Statistics Cards */}
                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div
                        className="card bg-primary text-white"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTabSwitch("domains")}
                      >
                        <div className="body">
                          <div className="d-flex align-items-center">
                            <div className="icon-in-bg bg-white text-primary rounded">
                              <i className="fa fa-globe"></i>
                            </div>
                            <div className="ml-3">
                              <span className="">Total Domains</span>
                              <h4 className="mb-0">{stats.totalDomains || 0}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div
                        className="card bg-success text-white"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTabSwitch("domains")}
                      >
                        <div className="body">
                          <div className="d-flex align-items-center">
                            <div className="icon-in-bg bg-white text-success rounded">
                              <i className="fa fa-check-circle"></i>
                            </div>
                            <div className="ml-3">
                              <span className="">Active Domains</span>
                              <h4 className="mb-0">{stats.totalActiveDomains || 0}</h4>
                              {(domainExpiryStats.expiringSoon > 0 || domainExpiryStats.criticalExpiry > 0) && (
                                <small className="text-white-50">
                                  {domainExpiryStats.criticalExpiry > 0 && (
                                    <span className="text-warning font-weight-bold">
                                      <i className="fa fa-exclamation-triangle mr-1"></i>
                                      {domainExpiryStats.criticalExpiry} critical
                                    </span>
                                  )}
                                  {domainExpiryStats.criticalExpiry > 0 && domainExpiryStats.expiringSoon > 0 && " • "}
                                  {domainExpiryStats.expiringSoon > 0 && (
                                    <span className="text-info">
                                      <i className="fa fa-exclamation-circle mr-1"></i>
                                      {domainExpiryStats.expiringSoon} expiring soon
                                    </span>
                                  )}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div
                        className="card bg-info text-white"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTabSwitch("vip")}
                      >
                        <div className="body">
                          <div className="d-flex align-items-center">
                            <div className="icon-in-bg bg-white text-info rounded">
                              <i className="fa fa-users"></i>
                            </div>
                            <div className="ml-3">
                              <span className="">VIP Members</span>
                              <h4 className="mb-0">{vipMembers.length || 0}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div
                        className="card bg-warning text-white"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTabSwitch("keywords")}
                      >
                        <div className="body">
                          <div className="d-flex align-items-center">
                            <div className="icon-in-bg bg-white text-warning rounded">
                              <i className="fa fa-hashtag"></i>
                            </div>
                            <div className="ml-3">
                              <span className="">Keywords</span>
                              <h4 className="mb-0">{keywords.length || 0}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>

              <Tab eventKey="domains" title={<span><i className="fa fa-globe mr-2"></i>Domains</span>}>
                <div className="body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Domain Details</h5>
                    <button className="btn btn-primary btn-sm" onClick={handleDownloadDomainStats}>
                      <i className="fa fa-download mr-1"></i>
                      Download Excel
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-hover table-custom spacing8">
                      <thead>
                        <tr>
                          <th>Domain</th>
                          <th>Registrar</th>
                          <th>Creation Date</th>
                          <th>Expiration Date</th>
                          <th>Status</th>
                          <th>DNS Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        {domainDetails.length > 0 ? (
                          domainDetails.map((domain) => {
                            const expiryDate = domain.whoisInfo?.registrar_registration_expiration_date;
                            const isActive = isDomainActive(expiryDate);
                            const isNearingExpiry = isDomainExpiryNearing(expiryDate);
                            const isCriticalExpiry = isDomainCriticalExpiry(expiryDate);

                            return (
                              <tr
                                key={domain._id}
                                className={
                                  isCriticalExpiry ? "table-warning" :
                                  isNearingExpiry ? "table-info" : ""
                                }
                              >
                                <td>
                                  <div className="d-flex align-items-center">
                                    {isCriticalExpiry && (
                                      <i className="fa fa-exclamation-triangle text-danger mr-2" title="Expires within 7 days"></i>
                                    )}
                                    {isNearingExpiry && !isCriticalExpiry && (
                                      <i className="fa fa-exclamation-circle text-warning mr-2" title="Expires within 30 days"></i>
                                    )}
                                    <strong>{domain.domain}</strong>
                                  </div>
                                </td>
                                <td>{domain.whoisInfo?.registrar || "N/A"}</td>
                                <td>{formatDate(domain.whoisInfo?.creation_date)}</td>
                                <td>
                                  <span className={
                                    isCriticalExpiry ? "text-danger font-weight-bold" :
                                    isNearingExpiry ? "text-warning font-weight-bold" : ""
                                  }>
                                    {formatDate(expiryDate)}
                                  </span>
                                  {expiryDate && (
                                    <small className="d-block text-muted">
                                      {(() => {
                                        const daysUntilExpiry = Math.ceil((new Date(expiryDate) - new Date()) / (1000 * 60 * 60 * 24));
                                        if (daysUntilExpiry > 0) {
                                          return `${daysUntilExpiry} days left`;
                                        } else if (daysUntilExpiry === 0) {
                                          return "Expires today";
                                        } else {
                                          return `${Math.abs(daysUntilExpiry)} days overdue`;
                                        }
                                      })()}
                                    </small>
                                  )}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${
                                      !isActive ? "badge-danger" :
                                      isCriticalExpiry ? "badge-warning" :
                                      isNearingExpiry ? "badge-info" :
                                      "badge-success"
                                    }`}
                                  >
                                    {!isActive ? "Expired" :
                                     isCriticalExpiry ? "Critical" :
                                     isNearingExpiry ? "Expiring Soon" :
                                     "Active"}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => {
                                      setSelectedRowDetails(domain);
                                      setDetailsModal(true);
                                      setDetailsActiveTab('dns');
                                    }}
                                    style={{
                                      backgroundColor: "#17a2b8",
                                      borderColor: "#17a2b8",
                                      color: "#fff",
                                      borderRadius: "4px",
                                      padding: "4px 12px",
                                      transition: "all 0.3s ease",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px"
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor = "#138496";
                                      e.target.style.borderColor = "#117a8b";
                                      e.target.style.transform = "translateY(-1px)";
                                      e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor = "#17a2b8";
                                      e.target.style.borderColor = "#17a2b8";
                                      e.target.style.transform = "translateY(0)";
                                      e.target.style.boxShadow = "none";
                                    }}
                                  >
                                    <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                                    <span className="details-slider-action-btn-text">DNS Details</span>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              <div className="p-4">
                                <i className="fa fa-globe fa-3x text-muted mb-3"></i>
                                <h5 className="text-muted">No domains found</h5>
                                <p className="text-muted">Domain information will appear here once configured.</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {pagination.totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-3">
                      <nav aria-label="Page navigation">
                        <ul className="pagination">
                          <li className={`page-item ${pagination.page <= 1 ? "disabled" : ""}`}>
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(pagination.page - 1)}
                              disabled={pagination.page <= 1}
                            >
                              Previous
                            </button>
                          </li>

                          {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((page) => (
                            <li key={page} className={`page-item ${page === pagination.page ? "active" : ""}`}>
                              <button className="page-link" onClick={() => handlePageChange(page)}>
                                {page}
                              </button>
                            </li>
                          ))}

                          <li className={`page-item ${pagination.page >= pagination.totalPages ? "disabled" : ""}`}>
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(pagination.page + 1)}
                              disabled={pagination.page >= pagination.totalPages}
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </div>
              </Tab>

              <Tab eventKey="social" title={<span><i className="fa fa-share-alt mr-2"></i>Social Media</span>}>
                <div className="body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Social Media Profiles</h5>
                    <button className="btn btn-primary btn-sm" onClick={handleDownloadSocialMedia}>
                      <i className="fa fa-download mr-1"></i>
                      Download Excel
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-hover table-custom spacing8">
                      <thead>
                        <tr>
                          <th>Platform</th>
                          <th>Username</th>
                          <th>Profile URL</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {socialMediaData.length > 0 ? (
                          socialMediaData.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <i className={`fa fa-${item.platform?.toLowerCase() || 'globe'} mr-2`}></i>
                                {item.platform || "Unknown"}
                              </td>
                              <td>{item.username || item.handle || "N/A"}</td>
                              <td>
                                {item.url ? (
                                  <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                    {item.url.length > 50 ? `${item.url.substring(0, 50)}...` : item.url}
                                  </a>
                                ) : "N/A"}
                              </td>
                              <td>
                                <span className="badge badge-success">Active</span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              <div className="p-4">
                                <i className="fa fa-share-alt fa-3x text-muted mb-3"></i>
                                <h5 className="text-muted">No social media profiles found</h5>
                                <p className="text-muted">Social media monitoring will appear here once configured.</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Tab>

              <Tab eventKey="vip" title={<span><i className="fa fa-user-circle mr-2"></i>VIP Members</span>}>
                <div className="body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Executive Monitoring</h5>
                    <button className="btn btn-primary btn-sm" onClick={handleDownloadVipMembers}>
                      <i className="fa fa-download mr-1"></i>
                      Download Excel
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-hover table-custom spacing8">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Position</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vipMembers.length > 0 ? (
                          vipMembers.map((member, index) => (
                            <tr key={member._id || index}>
                              <td>
                                <div className="d-flex align-items-center">
                                  {/* <div className="avatar avatar-sm mr-3">
                                    <img
                                      src={member.image || "../assets/images/user.png"}
                                      alt={member.name || "VIP Member"}
                                      className="rounded-circle"
                                      onError={(e) => {
                                        e.target.src = "../assets/images/user.png";
                                      }}
                                    />
                                  </div> */}
                                  {member.name || "N/A"}
                                </div>
                              </td>
                              <td>{member.email || "N/A"}</td>
                              <td>{member.position || "N/A"}</td>
                              <td>
                                <span className="badge badge-info badge-lg">
                                  <i className="fa fa-star mr-1"></i>VIP
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              <div className="p-4">
                                <i className="fa fa-user-circle fa-3x text-muted mb-3"></i>
                                <h5 className="text-muted">No VIP members found</h5>
                                <p className="text-muted">VIP member information will appear here once configured.</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Tab>

              <Tab eventKey="keywords" title={<span><i className="fa fa-hashtag mr-2"></i>Keywords</span>}>
                <div className="body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Customer Keywords</h5>
                    <button className="btn btn-primary btn-sm" onClick={handleDownloadKeywords}>
                      <i className="fa fa-download mr-1"></i>
                      Download Excel
                    </button>
                  </div>
                  <div className="row">
                    {keywords.length > 0 ? (
                      keywords.map((keyword, index) => (
                        <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                          <div className="card border-primary">
                            <div className="body text-center py-4">
                              <div className="mb-2">
                                <i className="fa fa-hashtag fa-2x text-primary"></i>
                              </div>
                              <h5 className="mb-0">
                                <span className="badge badge-primary badge-lg px-3 py-2">{keyword}</span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="text-center p-5">
                          <i className="fa fa-hashtag fa-4x text-muted mb-4"></i>
                          <h5 className="text-muted mb-2">No keywords configured</h5>
                          <p className="text-muted">Configure monitoring keywords to track brand mentions and security alerts.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      </div>

      {/* DNS Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
          setDetailsActiveTab('dns');
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-server mr-2"></i>
              DNS Details
              {selectedRowDetails?.domain && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.domain}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                  setDetailsActiveTab('dns');
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-tabs">
            <button
              className={`details-slider-tab ${detailsActiveTab === 'dns' ? 'active' : ''}`}
              onClick={() => setDetailsActiveTab('dns')}
            >
              <i className="fa fa-server mr-2"></i>
              DNS Records
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {detailsActiveTab === 'dns' && (
                  <>
                    {/* DNS Overview Section */}
                    {selectedRowDetails?.dnsDetails && (
                      <div className="details-section">
                        <div className="details-section-title">
                          <i className="fa fa-info-circle"></i>
                          DNS Overview
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Status:</span>
                          <span className="details-info-value">
                            <span className={`badge ${selectedRowDetails.dnsDetails.status ? 'badge-success' : 'badge-danger'}`}>
                              {selectedRowDetails.dnsDetails.status ? 'Active' : 'Inactive'}
                            </span>
                          </span>
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Domain Name:</span>
                          <span className="details-info-value">{selectedRowDetails.dnsDetails.domainName || "N/A"}</span>
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Query Time:</span>
                          <span className="details-info-value">
                            {selectedRowDetails.dnsDetails.queryTime 
                              ? moment(selectedRowDetails.dnsDetails.queryTime).format("DD-MM-YYYY HH:mm:ss")
                              : "N/A"}
                          </span>
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Domain Registered:</span>
                          <span className="details-info-value">
                            <span className={`badge ${selectedRowDetails.dnsDetails.domainRegistered ? 'badge-success' : 'badge-warning'}`}>
                              {selectedRowDetails.dnsDetails.domainRegistered ? 'Yes' : 'No'}
                            </span>
                          </span>
                        </div>
                        {selectedRowDetails.dnsDetails.dnsTypes && (
                          <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                            <span className="details-info-label" style={{ marginBottom: "8px" }}>DNS Types Found:</span>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                              {Object.keys(selectedRowDetails.dnsDetails.dnsTypes).map((type) => (
                                <span key={type} className="badge badge-info mr-1">
                                  {type} ({selectedRowDetails.dnsDetails.dnsTypes[type]})
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* DNS Records Section */}
                    {renderDNSRecords()}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Management;
